import { Behaviour } from '../renderer/core/Behaviour';
/**
 * 当たり判定の基本クラス
 */
export class Collider extends Behaviour {
    test(ray) {
        return null;
    }
    ;
}
//# sourceMappingURL=Collider.js.map